import { ref } from 'vue';

export default function useComponentExcludeNull(props) {
  const buildExcludeNull = (excludeNullValues, excludeNullKeys) => {
    for (let key in excludeNullKeys) {
      let attribute = excludeNullKeys[key];
      excludeNullValues[attribute] = !!excludeNullValues[attribute];
    }

    return { ...excludeNullValues };
  };

  let resource = props.resource ?? props.models ?? props.model;
  let meta = props.meta ?? resource.meta ?? {};

  const localExcludeNull = ref(
    buildExcludeNull(
      ref(props.excludeNull ?? props.adjustments?.excludeNull ?? meta?.adjustments.excludeNull ?? {})
        .value,
      Object.keys({ ...meta }.columns)
    )
  );

  return {
    buildExcludeNull,
    localExcludeNull,
  };
}
